import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    SEND_USER_CPD_PROGRESS_NOTIFICATION: (body) => ({ body }),
    API: {
      SEND_USER_CPD_PROGRESS_NOTIFICATION: apiResourceActionCreator('`notification`')
    }
  }
})

export const apiAction = (authToken, body) => commonApiActions.authenticated.post(`${API_ENDPOINT}/reports/users/cpd-progress-notification`, authToken, body, actions.admin.api.sendUserCpdProgressNotification);

function* sendUserCpdProgressNotification(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.body));
}

const configuration = {
  name: 'sendUserCpdProgressNotification',
  action: actions,
  sagas: sendUserCpdProgressNotification,
  reducers: {
    request: (state, action) => ({
      ...state,
      isSendingNotification: true,
      error: undefined,
    }),
    success: (state, action) => ({
      ...state,
      isSendingNotification: false,
      error: undefined,
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isSendingNotification: false,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/sendUserCpdProgressNotification.js